import React from 'react';
// import { Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import logo from '../assest/images/zmu rADIO lOGO copy.png';
import universityLogo from '../assest/images/univercitylogo.png';

/**
 * مكون الفوتر
 * فوتر مبسط بتصميم عسكري رسمي
 */
const NewFooter = () => {
  const currentYear = new Date().getFullYear();

  // const socialLinks = [
  //   {
  //     name: 'فيسبوك',
  //     icon: Facebook,
  //     url: '#',
  //     color: 'hover:text-blue-400'
  //   },
  //   {
  //     name: 'تويتر',
  //     icon: Twitter,
  //     url: '#',
  //     color: 'hover:text-sky-400'
  //   },
  //   {
  //     name: 'انستغرام',
  //     icon: Instagram,
  //     url: '#',
  //     color: 'hover:text-pink-400'
  //   },
  //   {
  //     name: 'يوتيوب',
  //     icon: Youtube,
  //     url: '#',
  //     color: 'hover:text-red-500'
  //   }
  // ];

  return (
    <footer className="relative text-gray-800 py-12 border-t-4 border-gold" style={{ backgroundColor: '#D3CEC8' }}>
      <div className="container mx-auto px-4">
        {/* المحتوى الرئيسي */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-8">
          
          {/* الشعار الأيمن - شعار الإذاعة */}
          <div className="flex items-center justify-center md:justify-start w-full md:w-1/3">
            <div className="text-center md:text-right">
              <div>
                <img
                  src={universityLogo}
                  alt="جامعة زايد العسكرية"
                  className="w-36 h-36 md:w-40 md:h-40 object-contain mx-auto md:mx-0"
                />
              </div>
              {/* <h3 className="text-xl font-bold text-gold">
                إذاعة جامعة زايد العسكرية
              </h3> */}
            </div>
          </div>

          {/* وسائل التواصل الاجتماعي - الوسط */}
          {/* <div className="flex flex-col items-center justify-center w-full md:w-1/3">
            <h4 className="text-lg font-bold text-gold mb-4">
              تابعنا على
            </h4>
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm border-2 border-white/20 flex items-center justify-center transition-all duration-300 hover:scale-110 hover:border-gold ${social.color} hover:bg-white/20 hover:shadow-lg hover:shadow-gold/30`}
                    aria-label={social.name}
                  >
                    <Icon className="w-6 h-6" />
                  </a>
                );
              })}
            </div>
          </div> */}

          {/* الشعار الأيسر - شعار الجامعة */}
          <div className="flex items-center justify-center md:justify-end w-full md:w-1/3">
            <div className="text-center md:text-left">
              <div>
                <img
                  src={logo}
                  alt="إذاعة جامعة زايد العسكرية"
                  className="w-36 h-36 md:w-40 md:h-40 object-contain mx-auto md:mx-0"
                />
              </div>
              {/* <h3 className="text-xl font-bold text-gold">
                جامعة زايد العسكرية
              </h3> */}
            </div>
          </div>
        </div>

        {/* خط فاصل */}
        <div className="h-px bg-gradient-to-r from-transparent via-gold to-transparent mb-8"></div>

        {/* حقوق النشر */}
        <div className="text-center space-y-3">
          <p className="text-gray-800 text-lg font-semibold">
            جميع الحقوق محفوظة © {currentYear}
          </p>
          <p className="text-[#8B7355] text-base">
            إذاعة جامعة زايد العسكرية - دولة الإمارات العربية المتحدة
          </p>
          {/* <div className="flex items-center justify-center gap-2 text-sm text-gray-400">
            <span className="w-2 h-2 bg-gold rounded-full animate-pulse"></span>
            <span>البث المباشر 24/7</span>
          </div> */}
        </div>

        {/* تفاصيل إضافية */}
        {/* <div className="mt-8 text-center text-gray-400 text-sm">
          <p>
            📻 استمع إلينا على مدار الساعة | 🎙️ برامج متنوعة ومميزة | 🎵 أجمل الأغاني الوطنية
          </p>
        </div> */}
      </div>

      {/* تأثير الإضاءة الخلفية */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-96 h-96 bg-gold/5 rounded-full blur-3xl pointer-events-none"></div>
    </footer>
  );
};

export default NewFooter;
